import styled from '@emotion/styled';
import React from 'react';

import { color, font, shadow } from 'src/shared/styles/variables';
import { colors as dsColors } from '@modernhealth/vital-foundation';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FormInputTextarea } from '@modernhealth/vital-components';

const TextField = styled.textarea(
    {
        width: '100%',
        height: 150,
        borderRadius: 5,
        padding: 10,
        border: `1px solid ${color.linkWaterLight} !important `,
        boxShadow: `${shadow.regularShadow} !important `,
        color: color.fiord,
        '::placeholder': {
            color: color.baliHai,
            ...font.light(font.size.base),
        },
        '&:focus-visible': {
            boxShadow: `0px 0px 0px 4px ${dsColors.cyan20} !important`,
            outline: 'none',
        },
    },
    font.heavy(font.size.base),
);

interface Props {
    fieldId: string;
    value: string;
    onChange: (value: string) => void;
    onBlur?: (e: React.FocusEvent) => void;
    testID?: string;
    placeholder?: string;
}

/**
 * @deprecated
 *
 * Use {@link FormInputTextarea} from `@modernhealth/vital-components`
 */
export const DeprecatedTextArea: React.FC<Props> = ({
    fieldId,
    value,
    onChange,
    onBlur,
    placeholder = '',
    testID = '',
}) => {
    return (
        <TextField
            id={fieldId}
            name={fieldId}
            value={value}
            placeholder={placeholder}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            data-testid={testID}
        />
    );
};
